/* co-search-enhance.js — predictive-search enhancements (vanilla, no deps)
 * v1.2.0 (2026-06-25)
 *  1. Matched-term highlight: wraps query words in product titles with <mark>.
 *  2. Wider resource net: requests products + collections + pages + articles +
 *     queries, so informational searches like "best treadmill" surface the
 *     relevant guide article / landing page (theme default omitted page+article).
 *  3. Hyphen/spacing-tolerant search: runs the query as typed; if it returns
 *     NOTHING, retries normalised variants so "sm25" === "sm-25" === "sm 25"
 *     and "x-515" / "x 515" still find "X515". Fallback only fires on a truly
 *     empty result, so searches that already return something are never altered.
 */
(function () {

  var RESOURCES = 'product,collection,page,article,query';

  /* ---------- 1. Matched-term highlight ---------------------------------- */
  function escapeRegex(s){ return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function getTerm(wrap){
    var form = wrap.closest('[data-autocomplete-true]') || document;
    var input = form.querySelector('[data-q]') || document.querySelector('[data-autocomplete-true] [data-q]');
    return input ? input.value.trim() : '';
  }
  function highlight(wrap){
    var term = getTerm(wrap);
    var titles = wrap.querySelectorAll('.search__results__item .description__title');
    if (!titles.length) return;
    var words = term ? term.split(/\s+/).filter(Boolean).map(escapeRegex) : [];
    var re = words.length ? new RegExp('(' + words.join('|') + ')', 'ig') : null;
    titles.forEach(function (el) {
      if (el.dataset.cosHl === term) return;
      var txt = el.textContent;
      el.innerHTML = re ? txt.replace(re, '<mark class="cos-srch-hl">$1</mark>') : txt;
      el.dataset.cosHl = term;
    });
  }
  function observe(wrap){
    if (wrap.__cosObserved) return; wrap.__cosObserved = true;
    new MutationObserver(function(){ highlight(wrap); }).observe(wrap, { childList: true, subtree: true });
    highlight(wrap);
  }
  function scan(){ document.querySelectorAll('.search__results-wrapper').forEach(observe); }

  /* ---------- 2/3. Resource net + hyphen/spacing-tolerant search --------- */
  function variants(term){
    var out = [term];
    var spaced = term.replace(/-/g, ' ')
                     .replace(/([A-Za-z])(\d)/g, '$1 $2')
                     .replace(/(\d)([A-Za-z])/g, '$1 $2')
                     .replace(/\s+/g, ' ').trim();
    if (spaced && out.indexOf(spaced) === -1) out.push(spaced);
    var joined = term.replace(/[\s-]+/g, '');
    if (joined && out.indexOf(joined) === -1) out.push(joined);
    return out;
  }
  function installFallback(){
    var PS = window.PXUTheme && window.PXUTheme.predictiveSearch;
    if (!PS || PS.__cosFallback) return !!PS;
    PS.__cosFallback = true;
    PS.getResults = function (term, $this) {
      var layout = window.PXUTheme.theme_settings.header_layout;
      if (term.length === 0) {
        if (layout === 'vertical' || layout === 'search_focus') PS.unlockBodyScroll();
        PS.clearResults();
        return;
      }
      var rt = PS.vars.searchResourceType;
      var restrict = rt && ('searchResourceType' in $this[0].dataset);
      var base = window.PXUTheme.routes.predictive_search_url;
      var qs = '&resources[type]=' + (restrict ? rt : RESOURCES);
      var cand = variants(term), idx = 0, firstHtml = null;
      function fetchTerm(t){
        return fetch(base + '?q=' + encodeURIComponent(t) + '&section_id=predictive-search' + qs)
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      }
      function hasResults(html){ return html.indexOf('search__results__item') !== -1; }
      function tryNext(){
        return fetchTerm(cand[idx]).then(function (html) {
          if (idx === 0) firstHtml = html;
          if (hasResults(html) || idx >= cand.length - 1) return hasResults(html) ? html : firstHtml;
          idx++; return tryNext();
        });
      }
      tryNext().then(function (html) {
        PS.displayResults(html, $this);
        if ((layout === 'vertical' || layout === 'search_focus') && $this.closest('.jsHeader').length > 0) PS.lockBodyScroll();
      }).catch(function(){ /* network error — leave prior results */ });
    };
    return true;
  }

  /* ---------- boot ------------------------------------------------------- */
  function boot(){
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    (function waitPS(){
      if (installFallback() || tries++ > 40) return;
      setTimeout(waitPS, 100);
    })();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
